var exports = {
  "Im": "x234b8571--66148c--comment",
  "kL": "x234b8571--66148c--container",
  "x6": "x234b8571--66148c--button",
};

module.exports = exports;
